import Repository from '@/api/Repository'

const resource = '/treefolder'

export default {
  add(data, config = {}) {
    return Repository.post(`${resource}/add`, data, config)
  },
}
